document.querySelector('.o-footer .a-button[data-action="scroll-to-top"]')?.addEventListener('click', () => {
	document.scrollingElement.scrollTo({
		top: 0,
	});
});
